import axios from './http'

// 财务管理模块中供应商数据
export function getPhone (code,cap) {
  return axios({
    method: 'get',
    url: '/api/phone/get?code='+code+(cap?'&captchaCode='+cap:'')
  })
}
